<div class="action-item">
  <div class="action-item__info">
    @if (type === 'link') {
    <a href="{{ description() }}" target="_blank" rel="noopener noreferrer"
      ><strong class="action-item__title">{{ title() }}</strong></a
    >
    } @else {
    <strong class="action-item__title">{{ title() }}</strong>

    } @if (showDescription()) {
    <p class="action-item__description">{{ description() }}</p>
    }
  </div>

  <div class="action-item__actions">
    @if (enableAdd()) {
    <app-button
      [className]="'action-item__btn action-item__btn--add'"
      [icon]="'/assets/icons/plus-purple-background.svg'"
      (click)="onAdd()">
    </app-button>
    } @if (enableEdit() && !editingState()) {
    <app-button
      [className]="'action-item__btn action-item__btn--edit'"
      [icon]="'/assets/icons/edit-purple.svg'"
      (click)="toggleEdit()">
    </app-button>
    } @if (enableDelete()) {
    <app-button
      [className]="'action-item__btn action-item__btn--delete'"
      [icon]="'/assets/icons/Eliminate.svg'"
      (click)="onDelete()">
    </app-button>
    }
  </div>
</div>

@if (showDivider()) {
<div class="action-item__divider"></div>
} @if (editingState()) {
<div class="action-item__editor">
  <ng-content></ng-content>
</div>
}
